(ns rothko.theme.sandi.core
  (:require [rothko.theme.sandi.audio.wave-player :as wave-player]
            [rothko.theme.sandi.button :as button]
            [rothko.theme.sandi.footer :as footer]
            [rothko.theme.sandi.form.radio :as radio-theme]
            [rothko.theme.sandi.header :as header]
            [rothko.theme.sandi.layout :as layout]
            [rothko.theme.sandi.link :as link]
            [rothko.theme.sandi.nav :as nav]
            [rothko.theme.sandi.panel :as panel]))

(def main
  {:styles
   {:rothko.audio.wave-player.component/progress-bar wave-player/progress-bar
    :rothko.audio.wave-player.component/controls wave-player/controls
    :rothko.audio.wave-player.component/titles wave-player/titles
    :rothko.audio.wave-player.component/wave-player wave-player/wave-player
    :rothko.button.component/button button/main
    :rothko.footer.component/footer footer/main
    :rothko.form.radio.component/radio radio-theme/radio
    :rothko.header.component/main header/main
    :rothko.layout.component/main layout/main
    :rothko.link.component/link link/link
    :rothko.nav.component/footer-item nav/footer-item
    :rothko.nav.component/nav nav/nav
    :rothko.nav.component/nav-item nav/nav-item
    :rothko.panel.component/panel panel/main}})
